import { useState } from 'react';
import { JoinsSheet } from './JoinsSheet';
import { EventPhoto } from './EventPhoto';
import { formatEventDateShort } from './eventDate';
import { useSubscription } from '../../hooks/useSubscription';

const PinIcon = ({ className = '' }) => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
      fill="currentColor"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
    <path
      d="M19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V6C21 4.897 20.103 4 19 4ZM19 20H5V9H19V20Z"
      fill="currentColor"
    />
  </svg>
);

// Миниатюра мероприятия в ленте: фон — фото, поверх — название и детали,
// ниже — кто идёт (без подписки аватары размыты) и кнопки «Хочу пойти» / «Пригласить»
export function EventCard({ event, onOpen, onJoin, onInvite }) {
  const [joinsOpen, setJoinsOpen] = useState(false);
  const { isActiveSubscription } = useSubscription();
  const subscribed = isActiveSubscription === true;

  const avatars = event.joinUsers || [];
  const extraCount = Math.max(0, (event.joins || 0) - avatars.length);

  return (
    <div className="w-full rounded-[16px] overflow-hidden bg-[#022424] font-raleway">
      {/* Фото-фон */}
      <div className="relative cursor-pointer" onClick={() => onOpen(event._id)}>
        <EventPhoto src={event.coverUrl} alt={event.title} className="w-full h-[339px] object-cover" />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'linear-gradient(to bottom, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.25) 26%, rgba(0,0,0,0.15) 45%, rgba(0,0,0,0.45) 62%, rgba(0,0,0,0.88) 100%)'
          }}
        />

        <p className="absolute top-3 left-3 right-3  drop-shadow-md text-white">
          <h2 className="text-white text-[22px] font-bold font-raleway leading-snug line-clamp-2">{event.title}</h2>
          <div className="flex items-center flex-wrap gap-2 text-[16px] font-medium mt-2">
            <span className="flex items-center gap-1.5">
              <img src="/icons/location.svg" alt="location" />

              {event.city}
            </span>
            <span className="flex items-center gap-1.5">
              <img src="/icons/calendar-small.svg" alt="calendar" />
              {formatEventDateShort(event.date)}
            </span>
          </div>
        </p>

        <div className="absolute bottom-3 left-3 right-3">
          {avatars.length > 0 && (
            <>
              <p className="text-[16px] font-bold text-white font-raleway mb-3">Хотят пойти:</p>
              <div className="flex items-center gap-2">
                <div
                  className={`flex items-center ${!subscribed && (avatars.length > 0 || event.joins > 0) ? 'cursor-pointer' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setJoinsOpen(true);
                  }}
                >
                  {avatars.slice(0, 3).map((photo, i) => (
                    <img
                      key={i}
                      src={photo}
                      alt=""
                      className={`w-[48px] h-[48px] rounded-full object-cover -ml-1.5 first:ml-0 ${
                        subscribed || i === (event.myJoinIndex ?? -1) ? '' : 'blur-[5px] select-none'
                      }`}
                    />
                  ))}

                  {avatars.length === 0 && event.joins > 0 && (
                    <span className="text-[12px] text-white/50 font-raleway">
                      {event.joins} {event.joins === 1 ? 'человек' : 'чел.'} хотят пойти
                    </span>
                  )}

                  {extraCount > 0 && <span className="ml-2 text-[18px] font-bold text-white">+{extraCount}</span>}
                </div>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setJoinsOpen(true);
                  }}
                  className="ml-auto text-[#A1F69E] text-[16px] font-bold"
                >
                  Узнать кто идёт
                </button>
              </div>
            </>
          )}

          <div className="flex gap-2 mt-3">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onJoin(event);
              }}
              className={`flex-1 h-[48px] rounded-[400px] text-[18px] font-medium font-raleway transition-colors ${
                event.isJoined
                  ? 'bg-[#010D0D] text-[#A1F69E] active:bg-[#043939]'
                  : 'bg-[#A1F69E] text-[#010D0D] active:bg-[#7DD279]'
              }`}
            >
              {event.isJoined ? 'Я иду' : 'Хочу пойти'}
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onInvite(event);
              }}
              className="flex-1 h-[48px] rounded-[400px] text-[18px] font-medium font-raleway bg-[#010D0D] text-white active:bg-white/20"
            >
              Пригласить
            </button>
          </div>
        </div>
      </div>

      <JoinsSheet event={event} isOpen={joinsOpen} onClose={() => setJoinsOpen(false)} />
    </div>
  );
}
